import { styled as o } from "styled-components";
import { MediaQuery as e } from "../../../../styles/variables.js";
const t = o.ul`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: 8px;
  transition: transform 0.7s ease-in-out;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${e.SCREEN_MD_UP} {
    overflow-x: hidden;
  }
`, n = o.li`
  flex-shrink: 0;
`;
export {
  t as Container,
  n as ListItem
};
